<p class="header">{{ 'stt.downloadW.notice' | translate }}</p>
<div class="content">
    <div class="col md-12">
        <span class="material-icons sound">
        save
        </span> 
    </div>
    <p>{{ text | translate}}</p>

    <div class="buttons-box">
        <a class="button-primary no" (click)="closeModal()"  mat-dialog-close>{{ 'stt.downloadW.not' | translate }}</a> 
        <a class="button-primary" (click)="handlerSubmit()" mat-dialog-close>{{ 'stt.downloadW.yes' | translate }}</a>
    </div>
</div>
